/* M3 HOCl Amazon deal page. Reads window.M3HOCL (set by the "Deal settings" section). */
(function () {
  var D = window.M3HOCL || {};

  /* ---- deal values into every gate (also run inline by the gate snippet, this is the fallback) ---- */
  function fill() {
    document.querySelectorAll('[data-deal]').forEach(function (el) {
      var k = el.getAttribute('data-deal');
      if (D[k] != null && D[k] !== '') el.textContent = D[k];
    });
    document.querySelectorAll('[data-amz]').forEach(function (a) { if (D.amazon_url) a.href = D.amazon_url; });
  }
  fill();

  /* ---- countdown: N hours from first view, kept across refresh ---- */
  var timers = document.querySelectorAll('[data-timer]');
  if (timers.length && D.countdown_hours > 0) {
    var KEY = 'm3_hocl_deal_end', end = 0, now = Date.now();
    try { end = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    if (!end || end < now) { end = now + D.countdown_hours * 3600 * 1000; try { localStorage.setItem(KEY, String(end)); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var t = Math.floor(s / 3600) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      timers.forEach(function (el) { el.textContent = t; });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---- email gate: Klaviyo subscribe, pixel, redirect ---- */
  function subscribeOne(email, source, listId) {
    var body = { data: { type: 'subscription', attributes: { custom_source: source || 'HOCl Amazon LP', profile: { data: { type: 'profile', attributes: { email: email, properties: { 'HOCl LP': 'yes' } } } } }, relationships: { list: { data: { type: 'list', id: listId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(D.klaviyo_company_id), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' }, body: JSON.stringify(body), keepalive: true
    }).then(function (r) { return r.ok || r.status === 202 ? 'ok' : 'error ' + r.status; }).catch(function () { return 'network'; });
  }
  function subscribe(email, source) {
    if (!D.klaviyo_company_id) return Promise.resolve('skipped');
    var lists = [D.klaviyo_list_id, D.klaviyo_list_id_2].filter(Boolean);
    if (!lists.length) return Promise.resolve('skipped');
    return Promise.all(lists.map(function (id) { return subscribeOne(email, source, id); }));
  }
  function pixel(email) {
    try {
      if (typeof fbq === 'function') {
        var id = 'lead-' + Date.now();
        fbq('track', 'Lead', { content_name: 'HOCl Amazon LP' }, { eventID: id });
        fbq('trackCustom', 'AmazonClick', { content_name: 'HOCl Amazon LP' });
      }
      if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email });
    } catch (e) {}
  }
  document.querySelectorAll('form[data-gate]').forEach(function (f) {
    var gate = f.closest('.hc-gate'), err = gate.querySelector('.err'), done = gate.querySelector('.done'), btn = f.querySelector('button');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (f.email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = D.error_text || 'Check the email address and try again.'; err.hidden = false; return; }
      err.hidden = true; btn.disabled = true;
      pixel(email);
      var go = function () { if (D.amazon_url) window.location.href = D.amazon_url; };
      var timeout = new Promise(function (res) { setTimeout(function () { res('timeout'); }, 1500); });
      Promise.race([subscribe(email, gate.getAttribute('data-source')), timeout]).then(function () {
        f.hidden = true; done.hidden = false;
        setTimeout(go, D.redirect_delay_ms != null ? D.redirect_delay_ms : 700);
      });
    });
  });

  /* ---- carousels ---- */
  document.querySelectorAll('[data-car]').forEach(function (car) {
    var track = car.querySelector('.hc-track'), prev = car.querySelector('[data-prev]'), next = car.querySelector('[data-next]'), count = car.querySelector('.count');
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;
    var step = function () { return items[0].getBoundingClientRect().width + 16; };
    var sync = function () {
      var i = Math.min(Math.round(track.scrollLeft / step()), items.length - 1);
      if (count) count.textContent = (i + 1) + ' / ' + items.length;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---- creator videos: autoplay muted when visible, tap to unmute ---- */
  var vids = document.querySelectorAll('.hc-clip video');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { io.observe(v); });
  }
  document.querySelectorAll('.hc-clip .mute').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.parentNode.querySelector('video'); if (!v) return;
      v.muted = !v.muted; b.textContent = v.muted ? '🔇' : '🔊'; if (!v.muted) v.play().catch(function () {});
    });
  });

  /* ---- sticky CTA: show after the hero gate scrolls away, hide at the final gate, click scrolls to it ---- */
  document.querySelectorAll('[data-sticky]').forEach(function (bar) {
    var target = document.querySelector(bar.getAttribute('data-target') || '#deal');
    var firstGate = document.querySelector('.hc-hero .hc-gate') || document.querySelector('.hc-gate');
    var after = bar.getAttribute('data-after') || 'gate';
    var hideAtTarget = bar.getAttribute('data-hide-at-target') === 'true';
    var pastTrigger = after === '0', atTarget = false;
    bar.hidden = false;
    var apply = function () {
      var on = pastTrigger && !(hideAtTarget && atTarget);
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('hc-has-sticky', on);
    };
    if (after === 'gate' && firstGate && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { pastTrigger = !en.isIntersecting && en.boundingClientRect.top < 0; apply(); });
      }, { threshold: 0 }).observe(firstGate);
    } else if (after !== '0') {
      var px = after === 'gate' ? 600 : parseInt(after, 10) || 400;
      var onScroll = function () { pastTrigger = window.scrollY > px; apply(); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { atTarget = en.isIntersecting; apply(); }); }, { threshold: 0.25 }).observe(target);
    }
    var go = bar.querySelector('[data-sticky-go]');
    if (go) go.addEventListener('click', function () {
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var input = target.querySelector('input[type=email]');
      if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 700);
      try { if (typeof fbq === 'function') fbq('trackCustom', 'StickyCTAClick', { content_name: 'HOCl Amazon LP' }); } catch (e) {}
    });
    apply();
  });

  /* ---- label zoom: tap the label image to open it full size ---- */
  document.querySelectorAll('[data-zoom]').forEach(function (b) {
    b.addEventListener('click', function () {
      var src = b.getAttribute('data-zoom'), img = b.querySelector('img');
      var box = document.createElement('div'); box.className = 'hc-lightbox'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Label, full size');
      var big = document.createElement('img'); big.src = src; big.alt = img ? img.alt : 'Label';
      var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
      box.appendChild(big); box.appendChild(x); document.body.appendChild(box);
      var close = function () { if (box.parentNode) box.parentNode.removeChild(box); document.removeEventListener('keydown', esc); b.focus(); };
      var esc = function (e) { if (e.key === 'Escape') close(); };
      box.addEventListener('click', close); document.addEventListener('keydown', esc); x.focus();
    });
  });

  /* theme editor: re-run when a section reloads */
  document.addEventListener('shopify:section:load', function () { fill(); });
})();
